<script>
import PilotiVnos from "./Piloti_vnos.vue"
import DropDown from '../reUse/DropDown.vue';
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/Sifranti_Piloti-sl.json';
import en from '@/Prevodi/Sifranti_Piloti-en.json';
import it from '@/Prevodi/Sifranti_Piloti-it.json';
export default {
  components: {
    'PilotiVnos': PilotiVnos,
    DropDown,
    Notification
  },
  props: {},
  emits: ['odjava'],
  data() {
    return {
      prikaz: 'vnosi',
      piloti: [],
      izbranPilot: [],
      urejanje: false,
      idUrejanja: '',
      uIme: '',
      uPriimek: '',
      uNaslov: '',
      uPosta: '',
      uKraj: '',
      uEmail: '',
      uTelefon: '',
      uKlub: '',
      uNJadralno: '',
      uNMotorno: '',
      uStartJadralno: '',
      uInstruktor: false,
      uInstruktorJ: false,
      uInstruktorUL: false,
      uVlecniR: false,
      ujadralniPilot: false,
      umotorniPilot: false,
      uUltraPilot: false,
      uKmJadralno: '',
      uOpomba: '',
      uLicenca: '',
      dKlub: false,
      klubi: [],
      searchPilot: '',
      podatkiQR: '',
      linkQR: '',
      veljavnostQR: '',
      vabilo: false,
      zeRegistriran: false,
      text: '',
      types: '',
      ShowNoti: false,
      idIzbrisa: '',
      pot: config.baseUrl,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
  },
  mounted() {
    this.Read();
    this.ReadKlubi();
  },
  computed: {
    SearchPilot() {
      if (this.searchPilot !== '') {
        return this.piloti.filter(pilot =>
            pilot.ime.toLowerCase().includes(this.searchPilot.toLowerCase()) ||
            pilot.priimek.toLowerCase().includes(this.searchPilot.toLowerCase()) ||
            pilot.sifra.toLowerCase().includes(this.searchPilot.toLowerCase())
        );
      } else {
        return this.piloti;
      }
    },
  },
  methods: {
    Read() {
      axios.get('./api/sifranti/piloti/izpis/').then((response) => {
        this.piloti = response.data.piloti;
        this.piloti = this.piloti.filter(pilot => pilot.aktiven === true);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    ReadKlubi() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Details(id) {
      this.izbranPilot = this.piloti.filter(pilot => pilot.id === id);
      $(this.$refs.modalKartice).modal('show');
    },
    PridobiQR() {
      var podatki = new URLSearchParams();
      podatki.append('uEmail', this.izbranPilot[0].email);
      podatki.append('ime', this.izbranPilot[0].ime);
      podatki.append('priimek', this.izbranPilot[0].priimek);
      podatki.append('tel', this.izbranPilot[0].telefon);
      axios.post('./api/registracija/povabi/', podatki, {withCredentials: true}).then((response) => {
        this.linkQR = response.data.podatki.link;
        this.veljavnostQR = response.data.podatki.veljavnost;
        setTimeout(() => {
          this.KreirajQR(response.data.podatki.link);
          this.vabilo = true;
        }, 100);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.status === 400) {
          this.zeRegistriran = true;
          this.text = napaka.response.data.napaka;
          this.types = 'Napaka';
          this.ShowNoti = true;
        }
      });
    },
    KreirajQR(vsebina) {
      var qrcode = new QRCode("qrKoda", {
        text: vsebina,
        width: 130,
        height: 130,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    DeliQR() {
      this.podatkiQR = $(this.$refs.slikaQR).children().last().attr('src'); //shranimo podatke o sliki
      var podatki = new URLSearchParams();
      podatki.append('qr', this.podatkiQR);
      podatki.append('email', this.izbranPilot[0].email);
      podatki.append('linkQR', this.linkQR);
      podatki.append('veljavnostQR', this.veljavnostQR);
      axios.post('./api/registracija/povabi/', podatki, {withCredentials: true}).then((response) => {
        // alert('povabilo poslano!');
        this.text = 'povabilo poslano!';
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri kreiranju povabila. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri kreiranju povabila.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    DetailsOff() {
      $(this.$refs.modalKartice).modal('hide');
      //ponastavitev vrednosti
      this.uIme = '';
      this.uPriimek = '';
      this.idUrejanja = '';
      this.uNaslov = '';
      this.uPosta = '';
      this.uKraj = '';
      this.uEmail = '';
      this.uTelefon = '';
      this.uKlub = '';
      this.uNJadralno = '';
      this.uNMotorno = '';
      this.uStartJadralno = '';
      this.uKmJadralno = '';
      this.uOpomba = '';
      this.uLicenca = '';
      this.uInstruktor = false;
      this.uInstruktorJ = false;
      this.uInstruktorUL = false;
      this.uVlecniR = false;
      this.ujadralniPilot = false;
      this.umotorniPilot = false;
      this.uUltraPilot = false;
      this.urejanje = false;
      this.izbranPilot = [];
      this.vabilo = false;
      this.zeRegistriran = false;
    },
    potrdiIzbris(id) {
      this.idIzbrisa = id;
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      // BRISANJE
      let izbris = new URLSearchParams();
      izbris.append("id_brisanja", this.idIzbrisa);
      axios
          .post("./api/sifranti/piloti/brisi/", izbris)
          .then((response) => {
            // $(this.$refs.modalObracunMotZapisa).modal('hide');
            this.Read();
            this.DetailsOff();
            this.text = "Zapis uspešno pobrisan";
            this.types = "Uspešno";
            this.ShowNoti = true;
            this.idIzbrisa = '';
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.sporocilo !== undefined) {
              this.text = 'Napaka pri brisanju podatkov. ' + napaka.response.data.sporocilo;
            } else {
              this.text = 'Napaka pri brisanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.urejanje = true;
      this.uIme = this.izbranPilot[0].ime;
      this.uPriimek = this.izbranPilot[0].priimek;
      this.uNaslov = this.izbranPilot[0].naslov;
      this.uPosta = this.izbranPilot[0].posta;
      this.uKraj = this.izbranPilot[0].kraj;
      this.uEmail = this.izbranPilot[0].email;
      this.uTelefon = this.izbranPilot[0].telefon;
      this.uKlub = this.izbranPilot[0].klub;
      this.uNJadralno = this.izbranPilot[0].nalet_jadralno;
      this.uNMotorno = this.izbranPilot[0].nalet_motorno;
      this.uStartJadralno = this.izbranPilot[0].start_jadralno;
      this.uKmJadralno = this.izbranPilot[0].kilometri_jadralno;
      this.uOpomba = this.izbranPilot[0].opomba;
      this.uInstruktor = this.izbranPilot[0].instruktor;
      this.uInstruktorJ = this.izbranPilot[0].instruktor_jadralno;
      this.uInstruktorUL = this.izbranPilot[0].instruktor_ultralight;
      this.uVlecniR = this.izbranPilot[0].vlecni_rating;
      this.ujadralniPilot = this.izbranPilot[0].jadralni_pilot;
      this.umotorniPilot = this.izbranPilot[0].motorni_pilot;
      this.uUltraPilot = this.izbranPilot[0].ultralight_pilot;
      this.uLicenca = this.izbranPilot[0].licenca;
    },
    PosodobiZapis() {
      var podatki = new URLSearchParams();
      podatki.append('ime', this.uIme);
      podatki.append('priimek', this.uPriimek);
      podatki.append('idU', this.idUrejanja);
      podatki.append('naslov', this.uNaslov);
      podatki.append('posta', this.uPosta);
      podatki.append('kraj', this.uKraj);
      podatki.append('email', this.uEmail);
      podatki.append('telefon', this.uTelefon);
      podatki.append('klub', this.uKlub);
      podatki.append('nalet_jadralno', this.uNJadralno);
      podatki.append('nalet_motorno', this.uNMotorno);
      // podatki.append('', this.uStartJadralno);
      // podatki.append('', this.uKmJadralno);
      podatki.append('opomba', this.uOpomba);
      podatki.append('licenca', this.uLicenca);
      podatki.append('vlecni_rating', this.uVlecniR);
      podatki.append('jadralni_pilot', this.ujadralniPilot);
      podatki.append('motorni_pilot', this.umotorniPilot);
      podatki.append('ultralight_pilot', this.uUltraPilot);
      podatki.append('instruktor', this.uInstruktor);
      podatki.append('instruktor_jadralno', this.uInstruktorJ);
      podatki.append('instruktor_ultralight', this.uInstruktorUL);
      axios.post('./api/sifranti/piloti/uredi/', podatki, {withCredentials: true}).then((response) => {
        //reaktivna posodobitev podatkov pilota
        this.izbranPilot[0].ime = this.uIme;
        this.izbranPilot[0].priimek = this.uPriimek;
        this.izbranPilot[0].naslov = this.uNaslov;
        this.izbranPilot[0].posta = this.uPosta;
        this.izbranPilot[0].kraj = this.uKraj;
        this.izbranPilot[0].email = this.uEmail;
        this.izbranPilot[0].telefon = this.uTelefon;
        this.izbranPilot[0].klub = this.uKlub;
        this.izbranPilot[0].nalet_jadralno = this.uNJadralno;
        this.izbranPilot[0].nalet_motorno = this.uNMotorno;
        this.izbranPilot[0].start_jadralno = this.uStartJadralno;
        this.izbranPilot[0].kilometri_jadralno = this.uKmJadralno;
        this.izbranPilot[0].opomba = this.uOpomba;
        this.izbranPilot[0].licenca = this.uLicenca;
        this.izbranPilot[0].instruktor = this.uInstruktor;
        this.izbranPilot[0].instruktor_jadralno = this.uInstruktorJ;
        this.izbranPilot[0].instruktor_ultralight = this.uInstruktorUL;
        this.izbranPilot[0].vlecni_rating = this.uVlecniR;
        this.izbranPilot[0].jadralni_pilot = this.ujadralniPilot;
        this.izbranPilot[0].motorni_pilot = this.umotorniPilot;
        this.izbranPilot[0].ultralight_pilot = this.uUltraPilot;
        //ponastavitev vrednosti
        this.uIme = '';
        this.uPriimek = '';
        this.idUrejanja = '';
        this.uNaslov = '';
        this.uPosta = '';
        this.uKraj = '';
        this.uEmail = '';
        this.uTelefon = '';
        this.uKlub = '';
        this.uNJadralno = '';
        this.uNMotorno = '';
        this.uStartJadralno = '';
        this.uKmJadralno = '';
        this.uOpomba = '';
        this.uLicenca = '';
        this.uInstruktor = false;
        this.uInstruktorJ = false;
        this.uInstruktorUL = false;
        this.uVlecniR = false;
        this.ujadralniPilot = false;
        this.umotorniPilot = false;
        this.uUltraPilot = false;
        this.urejanje = false;
        this.text = 'Posodobitev uspešna';
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodabljanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    selectKlub(id) {
      let klub = this.klubi.find(vl => vl.id === id);
      if (klub) {
        this.dKlub = false;
        this.uKlub = klub.naziv;
      }
    },
    OpenKlub() {
      this.dKlub = !this.dKlub;
    },
    IzvozCSV() {
      var podatki = new URLSearchParams();
      podatki.append('sifrantP', JSON.stringify(this.piloti));
      axios.post('./api/sifranti/csv/ ', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnosi'}" @click="prikaz = 'vnosi'">
              <i class="fas fa-edit"></i>
              <span>{{$t('navs.vnos')}}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'branje'}" @click="prikaz = 'branje'">
              <i class="fas fa-list"></i>
              <span>{{$t('navs.seznam')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <piloti-vnos v-if="prikaz == 'vnosi'" @prikaz="prikaz='branje'" @osvezi="Read()"/>
  <div v-else class='container p-4'>
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti=false" @closeNotification="ShowNoti = false" />
    </Transition>
    <br>
    <div class="col-12 sticky">
      <div class="container">
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" :placeholder="$t('search.placeholder')" v-model="searchPilot" /> <i class="fas fa-search iskalnik"></i><br/>
      </div>
    </div>
    <div class="pregled-povrsin-container">
      <div class='section-content'>
        <h4 class="text-white">
          <button class='btn btn-sm btn-outline-warning' :disabled="!piloti.length > 0" @click.prevent="IzvozCSV">
            {{$t('buttons.csv')}} <i class="fas fa-file-csv"></i>
          </button>
        </h4>
        <div class="desktop-grid">
          <div class="grid-container">
            <!-- Header row -->
            <div class="grid-header d-flex justify-content-between">
              <div class="grid-cell surface-label">{{$t('table.sifra')}}</div>
              <div class="grid-cell text-center">{{$t('table.ime')}}</div>
              <div class="grid-cell text-center">{{$t('table.priimek')}}</div>
              <div class="grid-cell text-center">{{$t('table.podrobno')}}</div>
            </div>

            <!-- data row -->
            <div class="grid-row d-flex justify-content-between" v-for='pilot in SearchPilot' @click.prevent='Details(pilot.id)'>
              <div class="grid-cell text-white surface-label">{{pilot.sifra}}</div>
              <div class="grid-cell text-white text-center">{{pilot.ime}}</div>
              <div class="grid-cell text-white text-center">{{pilot.priimek}}</div>
              <div class="grid-cell text-white text-center">
                <button type="button"
                        class="btn btn-primary mb-3"
                        @click.prevent='Details(pilot.id)'>
                  <span><i class="far fa-id-card"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile/Tablet Multi-Select View -->
        <div class="mobile-multiselect">
          <div class="remarks-item">
            <div class="area-selection">
              <div class="area-group d-flex justify-content-between">
                <div class="text-white text-center">{{$t('table.ime')}}</div>
                <div class="text-white text-center">{{$t('table.priimek')}}</div>
                <div class="text-white text-center">{{$t('table.podrobno')}}</div>
              </div>
              <div class="area-group d-flex justify-content-between" v-for='pilot in SearchPilot' @click.prevent='Details(pilot.id)'>
                <div class="text-white text-center">{{pilot.ime}}</div>
                <div class="text-white text-start">{{pilot.priimek}}</div>
                <div class="text-white text-center">
                  <button type="button"
                          class="btn btn-primary mb-3"
                          @@click.prevent='Details(pilot.id)'>
                    <span><i class="far fa-id-card"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PILOT PODROBNO -->
    <div class="modal modal-kartica" ref="modalKartice" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranPilot.length > 0" >
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="far fa-id-card fa-lg"></i> {{izbranPilot[0].ime}} {{izbranPilot[0].priimek}}</h5>
          </div>
          <div class="modal-body col-12">
            <ul class='list-group list-group-flush' v-if="!this.urejanje">
              <li class='list-group-item list-dark'>{{$t('modal.sifra')}} {{izbranPilot[0].sifra}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naslov')}} {{izbranPilot[0].naslov}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.posta')}} {{izbranPilot[0].posta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.kraj')}} {{izbranPilot[0].kraj}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.email')}} {{izbranPilot[0].email}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.telefon')}} {{izbranPilot[0].telefon}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.klub')}} {{izbranPilot[0].klub}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naletJ')}} {{izbranPilot[0].nalet_jadralno}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naletM')}} {{izbranPilot[0].nalet_motorno}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranPilot[0].opomba}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].instruktor, 'fa-check': izbranPilot[0].instruktor }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktorJ')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].instruktor_jadralno, 'fa-check': izbranPilot[0].instruktor_jadralno }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktorUL')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].instruktor_ultralight, 'fa-check': izbranPilot[0].instruktor_ultralight }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.vlecniR')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].vlecni_rating, 'fa-check': izbranPilot[0].vlecni_rating }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.jadralniP')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].jadralni_pilot, 'fa-check': izbranPilot[0].jadralni_pilot }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.motorniP')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].motorni_pilot, 'fa-check': izbranPilot[0].motorni_pilot }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.ultraP')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].ultralight_pilot, 'fa-check': izbranPilot[0].ultralight_pilot }"></i></li>
              <li class='list-group-item list-dark'>Licenca: {{izbranPilot[0].licenca}}</li>
              <li class='list-group-item list-dark'>
                <transition name="fade">
                  <div v-show="this.vabilo" class='container text-center'>
                    <span class='text-manjsi'>{{$t('vabilo.title')}}</span><br/>
                    <div v-show="this.vabilo" id="qrKoda" class='d-flex justify-content-center p-4 bg-light border-0 rounded-4 shadow-lg' ref="slikaQR">
                    </div>
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="this.zeRegistriran" class='container text-center'>
                    <span class='text-manjsi text-danger'>{{$t('vabilo.opomba')}}</span>
                  </div>
                </transition>
              </li>
            </ul>
            <ul class='list-group list-group-flush' v-else>
              <li class='list-group-item list-dark'>{{$t('labels.ime')}} <span class='text-lorange'>{{izbranPilot[0].ime}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uIme" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.priimek')}} <span class='text-lorange'>{{izbranPilot[0].priimek}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uPriimek" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.naslov')}} <span class='text-lorange'>{{izbranPilot[0].naslov}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uNaslov" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.posta')}} <span class='text-lorange'>{{izbranPilot[0].posta}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uPosta" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.kraj')}} <span class='text-lorange'>{{izbranPilot[0].kraj}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uKraj" v-model="uKraj" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.email')}} <span class='text-lorange'>{{izbranPilot[0].email}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uEmail" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.telefon')}} <span class='text-lorange'> {{izbranPilot[0].telefon}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uTelefon" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.klub')}} <span class='text-lorange'>{{izbranPilot[0].klub}} </span>
                <div class="container">
                  <label class="label-dropdown" for="namen">{{$t('labels.klubI')}} <button v-if="uKlub !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="uKlub = ''">Pobriši izbiro</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenKlub()">
                    <i v-show="!dKlub" class="fas fa-chevron-right"></i>
                    <i v-show="dKlub" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="klub" @click.prevent="OpenKlub">{{uKlub}}</button>
                  <transition name="fade">
                    <drop-down @klub="selectKlub" :data="klubi" type="klubi" class="drop-down-btn" v-if="dKlub" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('labels.naletJ')}} <span class='text-lorange'>{{izbranPilot[0].nalet_jadralno}}</span>  <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uNJadralno" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.naletM')}}  <span class='text-lorange'>{{izbranPilot[0].nalet_motorno}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uNMotorno" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.opomba')}} <span class='text-lorange'>{{izbranPilot[0].opomba}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uOpomba" required /></li>
              <li class='list-group-item list-dark'>{{$t('labels.instruktor')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].instruktor, 'fa-check': izbranPilot[0].instruktor }"></i> <input class="input-radio" type="checkbox" id="instruktor"  v-model="uInstruktor" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.instruktorJ')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].instruktor_jadralno, 'fa-check': izbranPilot[0].instruktor_jadralno }"></i> <input class="input-radio" type="checkbox" id="instruktorJ"  v-model="uInstruktorJ" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.instruktorUL')}} <i class="fas" :class="{'fa-times': !izbranPilot[0].instruktor_ultralight, 'fa-check': izbranPilot[0].instruktor_ultralight }"></i> <input class="input-radio" type="checkbox" id="instruktorJ"  v-model="uInstruktorUL" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.vlecniR')}}<i class="fas" :class="{'fa-times': !izbranPilot[0].vlecni_rating, 'fa-check': izbranPilot[0].vlecni_rating }"></i> <input class="input-radio" type="checkbox" id="vlecniR"  v-model="uVlecniR" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.jadralniP')}}<i class="fas" :class="{'fa-times': !izbranPilot[0].jadralni_pilot, 'fa-check': izbranPilot[0].jadralni_pilot }"></i> <input class="input-radio" type="checkbox" id="vlecniR"  v-model="ujadralniPilot" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.motorniP')}}<i class="fas" :class="{'fa-times': !izbranPilot[0].motorni_pilot, 'fa-check': izbranPilot[0].motorni_pilot }"></i> <input class="input-radio" type="checkbox" id="vlecniR"  v-model="umotorniPilot" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.ultraP')}}<i class="fas" :class="{'fa-times': !izbranPilot[0].ultralight_pilot, 'fa-check': izbranPilot[0].ultralight_pilot }"></i> <input class="input-radio" type="checkbox" id="vlecniR"  v-model="uUltraPilot" /></li>
              <li class='list-group-item list-dark'>{{$t('labels.licenca')}} <span class='text-lorange'>{{izbranPilot[0].licenca}}</span>  <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uLicenca" required /></li>
            </ul>
          </div>
          <div class="modal-footer col-12">
            <button class="btn btn-outline-success col-3" v-if="!this.urejanje && !this.vabilo" @click.prevent="PridobiQR()"><i class="fas fa-share"></i>{{$t('buttons.povabi')}}</button>
            <button class="btn btn-outline-success col-3" v-if="!this.urejanje && this.vabilo" @click.prevent="DeliQR()">{{$t('buttons.deli')}} <i class="fas fa-share"></i></button>&nbsp;
            <button class="btn btn-outline-warning col-3" v-if="!this.urejanje" @click.prevent="UrediZapis(izbranPilot[0].id)"><i class="fas fa-user-edit"></i>{{$t('buttons.uredi')}}</button>
            <button class="btn btn-outline-success col-12" v-else @click.prevent="PosodobiZapis()"><i class="fas fa-sync-alt"></i> {{$t('buttons.posodobi')}}</button>&nbsp;
            <button class="btn btn-outline-danger col-3" v-if="!this.urejanje" @click.prevent="potrdiIzbris(izbranPilot[0].id)"><i class="fas fa-trash"></i> {{$t('buttons.izbrisi')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>